import { Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import globalStyles from "./../../assets/styles/global.module.scss";
import style from "../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import GlobalButton from './globalButton/button';

const SocketConnectionLossPopup = () => {
    
    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={style.popupTitleTypography}>Connection Lost</Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />  

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={style.popupBodyGridContainer} gap={1}>

                                <Grid item xs={12} className={globalStyles.fullwidth}>
                                    <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                        Unable to establish connection to the server after multiple attempts.
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} className={globalStyles.fullwidth}>
                                    <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                        Please refresh and try again.
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container justifyContent={"center"} sx={{marginTop: "20px"}}>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Refresh"
                                                className='primaryButtonStyle'
                                                sx={{width: "130px"}}
                                                onClick={() => window.location.reload()}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default SocketConnectionLossPopup
